import { createFileRoute } from "@tanstack/react-router";
import { HelmCompass } from "@/components/helm-logo";

export const Route = createFileRoute("/terms")({
	component: TermsPage,
});

function TermsPage() {
	return (
		<div className="min-h-screen bg-background">
			<header className="border-b border-border">
				<div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3">
					<HelmCompass size={24} color="hsl(22 82% 31%)" strokeWidth={1.2} />
					<span
						className="font-display text-sm"
						style={{ letterSpacing: "0.18em" }}
					>
						H E L M
					</span>
				</div>
			</header>

			<main className="max-w-3xl mx-auto px-6 py-12 prose prose-neutral dark:prose-invert">
				<h1>Terms of Service</h1>
				<p className="text-muted-foreground text-sm">
					Version 1.0 &mdash; Last Updated: March 15, 2026
				</p>

				<h2>1. Acceptance of Terms</h2>
				<p>
					By accessing and using the Helm platform ("Service"), you accept and
					agree to be bound by the terms and provisions of this agreement. If you
					do not agree to abide by these terms, please do not use this Service.
				</p>

				<h2>2. Description of Service</h2>
				<p>
					Helm provides a campaign management platform designed to help political
					candidates organize, strategize, and execute their campaigns. The
					Service includes tools for voter outreach, fundraising, team
					management, strategy generation, and related campaign activities.
				</p>

				<h2>3. User Accounts</h2>
				<p>
					You are responsible for maintaining the confidentiality of your account
					credentials and for all activities that occur under your account. You
					agree to notify us immediately of any unauthorized use of your account.
				</p>

				<h2>4. Acceptable Use</h2>
				<p>
					You agree to use the Service only for lawful purposes and in accordance
					with applicable federal, state, and local laws, including but not
					limited to campaign finance regulations.
				</p>

				<h2>5. Data and Privacy</h2>
				<p>
					Your use of the Service is also governed by our{" "}
					<a href="/privacy" className="text-primary underline">
						Privacy Policy
					</a>
					, which is incorporated into these Terms by reference.
				</p>

				<h2>6. Intellectual Property</h2>
				<p>
					The Service and its original content, features, and functionality are
					owned by American Majority Project and are protected by United States
					and international copyright, trademark, and other intellectual property
					laws.
				</p>

				<h2>7. Limitation of Liability</h2>
				<p>
					In no event shall American Majority Project be liable for any indirect,
					incidental, special, consequential, or punitive damages arising out of
					or relating to your use of the Service.
				</p>

				<h2>8. Changes to Terms</h2>
				<p>
					We reserve the right to modify these Terms at any time. When we do, we
					will update the version number and date above. Continued use of the
					Service after changes constitutes acceptance of the new Terms.
				</p>

				<h2>9. Contact</h2>
				<p>
					If you have questions about these Terms, please contact us at{" "}
					<a
						href="mailto:legal@americamajority.org"
						className="text-primary underline"
					>
						legal@americamajority.org
					</a>
					.
				</p>
			</main>
		</div>
	);
}
